import * as React from 'react';
import Alert from '../../../../libs/controls/components/Alert';

interface DrawErrorsProps {
  fields?: Array<string>;
}

export const DrawErrors = ({ fields }: DrawErrorsProps) => (
  <div>
    {fields?.map((error) => (
      <Alert key={error}>{error}</Alert>
    ))}
  </div>
);
